// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#switch_entreprise .modal-content{background:linear-gradient(127.11deg,#697df4 9.25%,#3b51d5 90.37%)}#switch_entreprise .modal-body{padding-bottom:4vh}#switch_entreprise .modal-body h5{padding-top:2vh}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
